<template>
  <section class="AccountSelect">
    <InputDropdown
        v-model="$store.state.user.account"
        :searchable="false"
        :show-labels="false"
        :options="accounts"
        :allow-empty="false"
        track-by="id"
        track-label="shortSelectName"
        tooltip="name"
        close-on-select
    />
  </section>
</template>

<script>
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import InputDropdown from "@/components/Inputs/InputDropdown.component";
import {LOCAL_STORE_ACCOUNT, LOCAL_STORE_SEASON} from '@/local-store.keys';

export default {
  name: 'DDMCAF-AccountSelect',
  components: {InputDropdown},
  computed: {
    accounts() {
      return get(this, '$store.state.user.accounts.models', [])
    },
    account() {
      return get(this, '$store.state.user.account', []);
    }
  },
  created() {
    this.evaluateAccountValue();
  },
  watch: {
    accounts(accounts) {
      this.evaluateAccountValue(accounts)
    },
    account(user, oldValue) {
      if (user) {
        this.setAccountToLocaleStorage(user)
      }

      if (!!user && !!oldValue && oldValue.id !== user.id) {
        window.localStorage.setItem(LOCAL_STORE_SEASON, null)
      }

      if (
          !!user
          &&
          !!oldValue
          &&
          oldValue.id !== user.id
          &&
          !(window.location.href.indexOf("/home") > -1)
      ) {
        document.location.href = "/home";
      }

      this.getSeasons()
    }
  },
  methods: {
    getSeasons() {
      this.$store.dispatch('event/getSeasons')
    },
    evaluateAccountValue(accounts = this.accounts) {
      let localStorageValue = this.getAccountFromLocaleStorage()

      this.$store.state.user.account = localStorageValue ? localStorageValue : this.getDefaultAccountValue(accounts)
    },

    getAccountFromLocaleStorage() {
      // if we don't have accounts (organizations) we can't check if the account is valid
      if (isEmpty(this.accounts)) {
        return null
      }

      const accountData = window.localStorage.getItem(LOCAL_STORE_ACCOUNT);
      if (!accountData || accountData === '[object Object]') {
        return null
      }

      let storedAccount
      try {
        storedAccount = JSON.parse(accountData)
      } catch {
        return null
      }

      if (!storedAccount || storedAccount.id == null) {
        return null
      }

      const account = this.accounts.find(a => a.id == storedAccount.id)
      if (!account) {
        return null
      }

      this.setAccountToLocaleStorage(account)

      return account
    },

    setAccountToLocaleStorage(account) {
      window.localStorage.setItem(LOCAL_STORE_ACCOUNT, JSON.stringify(account))
    },

    getDefaultAccountValue(accounts) {
      if (isEmpty(accounts)) return null

      const defaultOrgId = get(this, '$store.state.user.model.settings.default_organization_id')
      if (defaultOrgId) {
        const defaultAccount = accounts.find(a => a.id == defaultOrgId)
        if (defaultAccount) return defaultAccount
      }

      return accounts[0]
    },
  }
}
</script>

<style lang="scss">
.AccountSelect {
}
</style>
